import { Directive, inject, input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HasToNavigate } from './has-to-navigate.interface';
import { GenericApplicationRouteMetadata } from '@shared/interfaces';

@Directive({
  selector: '[appNavigateOnModuleSubmit]',
  host: {
    '(moduleSubmit)': 'handleModuleSubmit($event)',
  },
})
export class NavigateOnModuleSubmitDirective {
  public routeMetadata = input.required<GenericApplicationRouteMetadata>({
    alias: 'appNavigateOnModuleSubmit',
  });

  private readonly _route = inject(ActivatedRoute);
  private readonly _router = inject(Router);

  protected handleModuleSubmit(event: Event): void {
    const moduleSubmitEvent = event as unknown as HasToNavigate;

    if (!moduleSubmitEvent.hasToNavigate) return;

    this._router.navigate(['..', this.routeMetadata().relativePath], {
      relativeTo: this._route,
    });
  }
}
